import { AUTH_SCOPE_ACCOUNT } from '@config/monetization.js'
import useAsync from '@shared/js/composables/useAsync.js'
import { REPLICATION_DELAY_MS } from '@config'
import { asyncSleep } from '@helpers/utils.js'
import authStore from '@stores/authStore.js'
import i18n from '@plugins/localisation.js'
import { readonly, ref } from 'vue'
import {
  getAuthenticateRequest,
  getSessionRequest,
  registerRequest,
} from '@services'

const gameWalletState = ref({})
const purchaseMod = ref(null)

export default function () {
  const { isMonRegistered, setMonToken, setUserMonetizationStatus } =
    authStore()
  const nonceToken = ref('unset')

  // get session nonce for widget
  const {
    loading: loadingSession,
    error: sessionError,
    data: sessionData,
    run: runSession,
  } = useAsync(
    (code, gameId) => getSessionRequest(code, gameId),
    i18n.global.t('marketplace.error_session')
  )
  async function getSession() {
    await runSession()

    if (!sessionError.value) {
      nonceToken.value =
        sessionData.value.session?.nonce ?? sessionData.value.nonce
    }

    return sessionError.value
  }

  // get monetization token for interacting with monetization api
  const {
    loading: loadingAuthenticate,
    error: authenticateError,
    data: authenticateData,
    run: runAuthenticate,
  } = useAsync(getAuthenticateRequest)

  async function authenticate() {
    await runAuthenticate()

    if (!authenticateError.value) {
      setMonToken(authenticateData.value, AUTH_SCOPE_ACCOUNT)
    }
  }

  // user registration
  const {
    loading: loadingRegister,
    error: errorRegister,
    data: registerData,
    run: runRegister,
  } = useAsync(registerRequest, i18n.global.t('marketplace.error_register'))
  async function registerUser() {
    if (isMonRegistered.value) return

    await runRegister()

    if (!errorRegister.value) {
      // Wait for registered to propagate before calling session
      await asyncSleep(REPLICATION_DELAY_MS)

      setUserMonetizationStatus(registerData.value?.monetization_status)
    }
  }

  function unsetNonce() {
    nonceToken.value = 'unset'
  }

  function setGameWallet(gameId, wallet) {
    gameWalletState.value = {
      ...gameWalletState,
      [gameId]: wallet,
    }
  }

  return {
    gameWallets: readonly(gameWalletState),
    nonce: readonly(nonceToken),
    loadingAuthenticate,
    runAuthenticate,
    loadingRegister,
    loadingSession,
    setGameWallet,
    registerUser,
    authenticate,
    purchaseMod,
    unsetNonce,
    getSession,
  }
}
